import { BoxProps, TextProps } from '@jfs/ui-new'
import { ViewStyle } from 'react-native'
import { Colors } from '../../util/util'

const DefaultStyle = {
  container: {
    flexGrow: 1,
    shadowOffset: { width: 1, height: 1 },
    shadowRadius: 3,
    shadowColor: Colors.LIGHT_GREY,
    borderWidth: 1,
    borderColor: Colors.BORDER_COLOR,
    zIndex: 10,
    backgroundColor: 'WHITE',
    padding: 16,
    marginHorizontal: 18,
    border: `1px solid ${Colors.SECONDARY_GREY}`,
    justifyContent: 'space-between',
    borderRadius: 4,
  } as BoxProps,
  tableContainer: (_loadingState: boolean) =>
    ({
      alignContent: 'center',
      flexGrow: 1,
    } as ViewStyle),
  emptyContainer: {
    alignContent: 'center',
    flex: 1,
  } as ViewStyle,
}

const styles = (breakpoint: number): any => {
  const isMobile = breakpoint < 560
  const isExtraaSmall = breakpoint <= 320
  const isSmall = breakpoint <= 360

  return {
    ...DefaultStyle,
    scrollContainer: {
      flexGrow: 1,
    },
    maincontainer: {
      margin: isMobile ? 0 : 16,
      flex: 1,
      backgroundColor: 'BACKGROUND',
    } as BoxProps,
    aligncenter: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flex: 1,
      paddingBottom: 16,
    } as ViewStyle,
    transactions: {
      ...DefaultStyle,
    },
    settlements: {
      ...DefaultStyle,
    },
    refunds: {
      ...DefaultStyle,
    },
    disputes: {
      ...DefaultStyle,
    },
    paymentlinks: {
      ...DefaultStyle,
    },
    bulkrefund: {
      ...DefaultStyle,
    },
    topBar: {
      flexDirection: 'row',
      justifyContent: isMobile ? 'flex-start' : 'space-between',
      zIndex: 12,
      // flex: 1,
      flexWrap: 'wrap',
    } as ViewStyle,
    mobileSelectionFix: {
      marginRight: isMobile ? 10 : 0,
      display: 'flex',
      flex: 1,
      flexWrap: 'wrap',
      flexDirection: 'row',
    } as ViewStyle,
    popupFieldSettings: {
      flex: 1,
      position: 'absolute',
      top: 0,
      left: 0,
      height: '100%',
      width: '100%',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: Colors.MODAL_SHADOW,
      zIndex: 1,
    } as ViewStyle,
    stickyHeader: {
      position: 'sticky',
      top: 0,
      paddingVertical: 16,
      backgroundColor: 'WHITE',
      zIndex: 100,
      // marginTop: 16,
    } as BoxProps,
    popupBody: {
      borderColor: Colors.WHITE,
      backgroundColor: Colors.WHITE,
      shadowOpacity: 0.6,
      shadowRadius: 5,
      borderRadius: 8,
    } as ViewStyle,
    refundBody: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-around',
    } as ViewStyle,
    errorView: {
      textAlign: 'center',
      margin: 8,
      color: 'RED',
    } as TextProps,
    loadingView: { width: '100%', textAlign: 'center' } as TextProps,
    hoverlistHeaderContainer: {
      flex: 1,
      flexDirection: 'row',
      // Todo
      backgroundColor: '#F8F8F8',
      paddingTop: 8,
      paddingBottom: 8,
      paddingLeft: 24,
      paddingRight: 24,
    } as ViewStyle,
    listItemContainer: {
      flex: 1,
      flexDirection: 'row',
      paddingTop: 16,
      paddingLeft: 24,
      paddingRight: 24,
    } as ViewStyle,
    listItemText: {
      minWidth: 100,
      maxWidth: 100,
      fontSize: 12,
      fontWeight: 'MEDIUM',
      color: 'BLACK_21',
      paddingRight: 16,
    } as TextProps,
    dateSelectorContainer: {
      flexDirection: 'row',
      marginTop: 20,
      flexWrap: 'wrap',
      maxWidth: '100%',
      justifyContent: 'flex-start',
    } as ViewStyle,
    hoverHeaderText: {
      minWidth: 100,
      maxWidth: 100,
      fontSize: 10,
      fontWeight: 'MEDIUM',
      color: 'GREY_MATTE',
      paddingRight: 16,
    } as TextProps,
    container: {
      shadowColor: Colors.BLACK,
      shadowOffset: {
        width: 0,
        height: 2,
      },
      shadowOpacity: 0.4,
      shadowRadius: 8,
      elevation: 5,
      overflow: 'hidden',
      borderRadius: 4,
      flex: 1,
      backgroundColor: Colors.WHITE,
      borderWidth: 1,
      borderColor: Colors.BORDER_COLOR,
    } as BoxProps,
    textLayout: {
      flex: 1,
      justifyContent: 'flex-start',
      flexDirection: 'row',
      padding: 0,
      margin: 0,
    } as ViewStyle,
    rowContainer: {
      flexDirection: 'row',
      marginTop: 20,
      minWidth: isMobile ? '100%' : 10,
      maxWidth: '100%',
      alignItems: 'center',
      flexWrap: 'wrap',
      justifyContent: 'flex-start',
    } as ViewStyle,
    generateContainer: {
      marginTop: isSmall ? 10 : 0,
    } as ViewStyle,
    hoverHeader: {
      padding: 24,
    } as ViewStyle,
    hoverDetails: {
      flex: 1,
      flexDirection: 'row',
      margin: 24,
      padding: 0,
    } as ViewStyle,
    hoverColumn: {
      flex: 1,
      flexDirection: 'column',
      margin: 0,
      padding: 0,
    } as ViewStyle,
    modalList: {
      backgroundColor: Colors.WHITE,
      position: 'relative',
      borderTopLeftRadius: 8,
      borderTopRightRadius: 8,
    } as ViewStyle,
    modalListItem: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      padding: 20,
      paddingVertical: 20,
      borderBottomWidth: 1,
      borderBottomColor: Colors.GREY_SEPARATOR,
    } as ViewStyle,
    bars: {
      backgroundColor: Colors.WHITE,
      padding: 8,
      marginTop: isExtraaSmall ? 20 : 0,
      shadowOffset: { width: 0, height: 2 },
      shadowRadius: 3,
      shadowColor: Colors.LIGHT_GREY,
      borderRadius: 4,
      zIndex: 4,
    } as ViewStyle,
    buttonContainer: {
      paddingHorizontal: 10,
      paddingVertical: 10,
    } as ViewStyle,
    fieldSettingContainer: {
      position: 'relative',
      bottom: 0,
      top: 0,
      zIndex: 10,
      right: 0,
      left: 0,
    } as ViewStyle,
    settlmentNote: {
      marginTop: 'auto',
      marginLeft: 16,
      padding: 2,
    } as ViewStyle,
    titlecontainer: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      height: 30,
    } as BoxProps,
    createLinkBtn: {
      width: 160,
      height: 30,
      bg: 'BLUE',
      underlayColor: 'PRIMARY',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 4,
      shadowRadius: 2,
      shadowColor: 'GRAY_SHADOW',
    } as BoxProps,
  }
}

export default styles
